import { targetAudienceItems } from '@/mocks/masterCourseData';
import { useTranslation } from 'react-i18next';

const TARGET_COUNT = 4;
const targetIndices = Array.from({ length: TARGET_COUNT }, (_, i) => i);

function splitParagraphs(value: string): string[] {
  return value.split(/\n{2,}/);
}

export default function TargetAudience() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {splitParagraphs(t('coursesMaster.target.label')).map((paragraph, index) => (
            <p key={index} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
              {paragraph}
            </p>
          ))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.target.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {splitParagraphs(t('coursesMaster.target.lead')).map((paragraph, index) => (
            <p key={index} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
          {targetIndices.map((index) => (
            <div key={index} className="flex items-start gap-4 bg-background-50 p-5 border border-background-200/60 group hover:border-accent-500/20 transition-colors duration-300">
              <span className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={`${targetAudienceItems[index]?.icon} text-accent-600 text-lg group-hover:text-accent-500 transition-colors duration-300`}></i>
              </span>
              <div>
                {splitParagraphs(t(`coursesMaster.target.${index}`)).map((paragraph, paragraphIndex) => (
                  <p key={paragraphIndex} className="text-[16px] text-foreground-800 tracking-[0.04em] leading-relaxed pt-0.5">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
